<template>
  <div class="app-banner">
    <div class="app-info">
      <img src="@/assets/app.jpeg" alt="Yummable App Icon" class="app-icon" />
      <a href="https://apps.apple.com/us/app/yummable/id6743863350" target="_blank">📱 Download Yummable!</a>
    </div>
    <button @click="$emit('close')">✖</button>
  </div>
</template>

<style scoped>
.app-banner {
  position: fixed;
  top: 0; /* 👈 Changed from bottom to top */
  left: 0;
  right: 0;
  background: #f8f9fa;
  padding: 1em;
  border-bottom: 1px solid #ccc; /* 👈 Optional for visual separation */
  z-index: 9999; /* 👈 Ensures it's on top of everything */
  border-radius: 0 0 12px 12px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
}

.app-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.app-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.app-banner a {
  color: #000;
  text-decoration: none;
  font-weight: 600;
}
</style>
